import { ethers } from "ethers";
import { Logger } from "./logging";
import { ChainIdsHex } from "./chains";

export async function treasuryCalculations(
    treasuryContract: ethers.Contract,
    provider: ethers.providers.Web3Provider,
    chain: string | null,
): Promise<void> {
    const signer = provider.getSigner();

    Logger.info("treasuryCalculations", { chain });

    if (chain !== ChainIdsHex.Avalanche || !chain) {
        Logger.info("treasuryCalculations - skipping");
        return;
    }

    Logger.info("treasuryCalculations - calling calculations function");
    await treasuryContract.connect(signer).calculations();
    Logger.info("treasuryCalculations - calculations function success");
}

// a temp function to handle treasury.calculations() for avalanche only
export function addTreasuryStepsCount(count: number, chain: string | null): number {
    if (chain !== null && chain === ChainIdsHex.Avalanche) {
        return count + 1;
    }

    return count;
}
